import script from "./ClickableInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickableInput.vue?vue&type=script&setup=true&lang=js"

import "./ClickableInput.vue?vue&type=style&index=0&id=175e8922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175e8922"]])

export default __exports__